// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-preview {
  border: 1px solid #e0d8b3;
  border-radius: 6px;
  padding: 8px;
  background: #fffdf6;
}

.media-preview__label {
  font-size: 12px;
  color: #7b6d34;
  margin-bottom: 6px;
}

.media-preview__thumb {
  width: 140px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #d7cfa8;
  cursor: zoom-in;
  background: #f7f2dd;
}

.media-preview__thumb img,
.media-preview__thumb video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-preview__actions {
  margin-top: 8px;
}

.media-viewer-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.media-viewer {
  width: min(96vw, 1200px);
  height: min(92vh, 820px);
  background: #111;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.media-viewer__toolbar {
  padding: 10px;
  background: #1d1d1d;
  color: #fff;
  display: flex;
  align-items: center;
}

.media-viewer__zoom {
  min-width: 56px;
  display: inline-block;
  text-align: center;
}

.media-viewer__content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  background: #000;
}

.media-viewer__content img {
  max-width: 100%;
  max-height: 100%;
  transform-origin: center center;
  transition: transform 120ms ease-out;
}

.media-viewer__content video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}


/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/media-preview.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,oyGAAoyG","sourcesContent":[".media-preview {\n  border: 1px solid #e0d8b3;\n  border-radius: 6px;\n  padding: 8px;\n  background: #fffdf6;\n}\n\n.media-preview__label {\n  font-size: 12px;\n  color: #7b6d34;\n  margin-bottom: 6px;\n}\n\n.media-preview__thumb {\n  width: 140px;\n  height: 90px;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid #d7cfa8;\n  cursor: zoom-in;\n  background: #f7f2dd;\n}\n\n.media-preview__thumb img,\n.media-preview__thumb video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.media-preview__actions {\n  margin-top: 8px;\n}\n\n.media-viewer-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  z-index: 2000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n}\n\n.media-viewer {\n  width: min(96vw, 1200px);\n  height: min(92vh, 820px);\n  background: #111;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.media-viewer__toolbar {\n  padding: 10px;\n  background: #1d1d1d;\n  color: #fff;\n  display: flex;\n  align-items: center;\n}\n\n.media-viewer__zoom {\n  min-width: 56px;\n  display: inline-block;\n  text-align: center;\n}\n\n.media-viewer__content {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: auto;\n  background: #000;\n}\n\n.media-viewer__content img {\n  max-width: 100%;\n  max-height: 100%;\n  transform-origin: center center;\n  transition: transform 120ms ease-out;\n}\n\n.media-viewer__content video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
